import { magnificPopup } from '../libs/magnific';

document.addEventListener('DOMContentLoaded', () => {
  const body = document.getElementsByTagName('body')[0];

  $('.js-modal-iframe').magnificPopup({
    type: 'iframe',
    overflowY: 'scroll',
    preloader: true,
    midClick: true,
    closeOnContentClick: false,
    closeBtnInside: true,
    callbacks: {
      beforeOpen() {
        this.st.mainClass = 'mfp-zoom-in';
      }
    }
  });

  $('.js-modal-inline').magnificPopup({
    type: 'inline',
    removalDelay: 600,
    preloader: false,
    midClick: true,
    closeOnContentClick: false,
    closeBtnInside: true,
    callbacks: {
      beforeOpen() {
        this.st.mainClass = this.st.el.attr('data-effect');
      }
    }
  });
});
